import React, { useContext } from 'react';
import { UserContext } from '../context/UserContext';

const Navigation = ({ currentPage, setCurrentPage, onLogout }) => {
  const { user } = useContext(UserContext);
  
  // Check if user is admin
  const isAdmin = user?.isAdmin || ['admin@sportiq.bet', 'artur@sportiq.bet', 'rocky@sportiq.bet'].includes(user?.email);

  return (
    <nav className="navigation">
      <div className="nav-brand">
        <h2>SportIQ</h2>
      </div>
      
      <div className="nav-links">
        <button 
          className={currentPage === 'dashboard' ? 'active' : ''}
          onClick={() => setCurrentPage('dashboard')}
        >
          Dashboard
        </button>
        
        <button onClick={onLogout} className="logout-btn">
          Logout
        </button>
      </div>
    </nav>
  );
};

export default Navigation;